import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, Divider, Grid2, IconButton, Paper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import { useGetAllIssuesOpenCloseQuery } from '../../../store/slices/apis/issuesDashboardSlice';
import TableDataGrid from 'components/grid/TableDataGrid';
import moment from 'moment';
import PaginationComponent from 'components/ui-components/PaginationComponent';
import { useParams } from 'react-router-dom';
import ExportToExcel from './ExportToExcel';
import ExportToPDF from './ExportToPDF';

const StyledTableHead = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '10px 10px 10px 15px', lineHeight: '100%'
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#000000', padding: '12px 12px 12px 15px', lineHeight: '100%',
}));


export default function IssuesPopup({ title, value, status, onClose, onOpen }) {

    const theme = useTheme();
    const { projectId } = useParams();
    const [pageNumber, setPageNumber] = React.useState(1);

    let searchparams = {
        projectId: projectId,
        page: pageNumber,
        pageSize: 10,
        currentStatus: 'Open',
        workflowStatus: 'Approve',
    }

    if (status == 'Module') {
        searchparams = {
            ...searchparams,
            module: value,
        }
    }
    else if (status == 'Severity') {
        searchparams = {
            ...searchparams,
            severity: value,
        }
    }
    else if (status === 'Actionable') {
        const today = new Date();
        const dayOfWeek = today.getDay();
        const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

        const monday = new Date(today);
        monday.setDate(today.getDate() - diffToMonday);

        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);

        const fromDate = monday.toISOString().split('T')[0];
        const toDate = sunday.toISOString().split('T')[0];

        searchparams = {
            ...searchparams,
            fromDate: fromDate,
            toDate: toDate,
        };
    }

    else if (status == 'Ageing Analysis') {

        const [from, to] = value.split(',');

        searchparams = {
            ...searchparams,
            fromDate: from,
            toDate: to,
        }
    }
    else if (status == 'TotalCritical') {
        searchparams = {
            ...searchparams,
            severity: 'critical',
        }
    }
    else {
        searchparams = {
            ...searchparams,
            //currentStatus: 'Open',
        }
    }

    const { data: openCloseData = [], error: openCloseError, isLoading: isOpenCloseLoading } = useGetAllIssuesOpenCloseQuery(
        searchparams);

    // Export complete data in PDF & Excel
    const searchparamsexport = {
        ...searchparams,
        page: 1,
        pageSize: 1000,
    }

    const { data: openCloseDataExport = [], error: openCloseExportError, isLoading: isOpenCloseExportLoading } = useGetAllIssuesOpenCloseQuery(
        searchparamsexport);
    // Export complete data in PDF & Excel

    const columns = [
        {
            name: "Issue No.",
            field: "issueNumber",
        },
        {
            name: "Consultant/Contractor",
            field: "contractor",
        },
        {
            name: "Package",
            field: "package",
        },
        {
            name: "Module",
            field: "module",
        },
        {
            name: "Issue Description",
            field: "issueDescription",
        },
        {
            name: "Status",
            field: "currentStatus",
        },
        {
            name: "Time Impact (days)",
            field: "timeImpact",
        },
        {
            name: "Cost Impact (INR)",
            field: "costImpact",
            renderer(params) {
                return (
                    <>
                        {params?.costImpact
                            ? `₹${params?.costImpact}`
                            : ""}
                    </>
                );
            },
            renderExport: (params) => `${params?.costImpact}`,
        },
        {
            name: "Workflow Status",
            field: "workflowStatus",
        },
        {
            name: "Severity",
            field: "severity",
        },
        {
            name: "Created Date",
            field: "createdDate",
            renderer(params) {
                return (
                    <>
                        {params?.createdDate
                            ? moment(params.createdDate).format("DD/MM/YYYY")
                            : ""}
                    </>
                );
            },
            //renderExport: (row) => new Date(row.createdAt).toLocaleDateString(),
            renderExport: (params) => moment(params.createddate).format("DD/MM/YYYY"),
        },
    ]

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={onOpen}
                sx={{
                    '& .MuiDialog-paper': {
                        overflowY: 'inherit'
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: '20px', color: '#696969' }}>{title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                <Divider sx={{ w: 1 }} />
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <Grid2 container spacing={2}>
                            <Grid2 container spacing={2} size={12}>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToExcel data={openCloseDataExport?.data?.issues} columns={columns} fileName="exportexcel_table" />
                                </Grid2>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToPDF data={openCloseDataExport?.data?.issues} columns={columns} fileName="exportpdf_table" />
                                </Grid2>
                            </Grid2>
                            <Grid2 size={12}>
                                <TableDataGrid columns={columns} data={openCloseData?.data?.issues} isLoading={isOpenCloseLoading} />

                                <Box sx={{ display: "flex", justifyContent: "end" }}>
                                    <PaginationComponent
                                        pageNumber={openCloseData?.data?.page || 1}
                                        totalPages={Math.ceil(openCloseData?.data?.totalRecords / openCloseData?.data?.pageSize) || 1}
                                        onPageChange={setPageNumber}
                                    />
                                </Box>
                            </Grid2>
                        </Grid2>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}